export enum DocumentType {
	DIGITAL_SIGNATURE = 'DIGITAL_SIGNATURE',
	NORMAL_FILE = 'NORMAL_FILE'
}